/* eslint react/no-array-index-key: "off" */
import React from 'react';
import {Helmet} from 'react-helmet-async';

const FEATURES = [
  ['📅', 'Show Google Calendar meetings'],
  ['📈', 'Visualization of visited web-sites and day productivity reports'],
  ['📝', 'Creation of to-dos and memos attached to time'],
  ['🕰️', 'Work hours and custom time ranges'],
  ['🎨', 'Themes & Color tuning'],
  ['🔗', 'Favorite Bookmarks'],
  ['🌤', 'Weather in your city & quote of the day'],
];

export function Website(): React.ReactElement {
  return (
    <main
      className="mx-auto max-w-[800px] px-6 py-14 text-2xl gap-y-6 flex flex-col"
      id="learn-more"
    >
      <Helmet>
        <script src="https://f.convertkit.com/ckjs/ck.5.js" />
        <script defer data-domain="daylatetab.com" src="https://p.hostedapp.one/js/plausible.js" />
      </Helmet>

      <header className="text-4xl text-cyan-700 mb-4 font-bold">
        <h1>✨ DayLate &ndash; New Tab Page with Day Progress</h1>
      </header>
      <p>
        We are working on a <strong>new tab extension</strong> for Google Chrome that shows the
        current day as a 24x60 progress bar. Each cell is a minute and you can see how the day
        passes.
      </p>

      <p>Sneak peak is at the top of this page.</p>
      <div>
        <p className="mb-4">
          The <strong>full version</strong> will include the following features:
        </p>

        <ul className="pl-4 flex flex-col gap-y-1 mb-4">
          {FEATURES.map(([icon, text], idx) => {
            return (
              <li className="flex gap-x-4" key={idx}>
                <span>{icon}</span>
                <span>{text}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div
        className="py-8
      items-center
      bg-orange-100
      rounded-2xl
      border border-orange-200 border-solid drop-shadow-md flex gap-4 flex-col text-lg"
      >
        <div>
          <p>Join our waitlist to be in the first row and try out the app.</p>
        </div>
        <form
          action="https://app.convertkit.com/forms/3124382/subscriptions"
          method="post"
          data-sv-form="3124382"
          data-uid="fbd9a14567"
          data-version="5"
          data-options='{"settings":{"after_subscribe":{"action":"message","success_message":"Success! We will let you know once the project is ready for tests. ","redirect_url":""},"analytics":{"google":null,"fathom":null,"facebook":null,"segment":null,"pinterest":null,"sparkloop":null,"googletagmanager":null},"modal":{"trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"powered_by":{"show":true,"url":"https://convertkit.com/features/forms?utm_campaign=poweredby&amp;utm_content=form&amp;utm_medium=referral&amp;utm_source=dynamic"},"recaptcha":{"enabled":false},"return_visitor":{"action":"show","custom_content":""},"slide_in":{"display_in":"bottom_right","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"sticky_bar":{"display_in":"top","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15}},"version":"5"}'
        >
          <div data-style="clean" className="flex gap-4">
            <div
              data-element="fields"
              data-stacked="false"
              className="flex flex-col md:flex-row gap-4 "
            >
              <div>
                <input
                  className="border border-solid border-gray-400 p-2 rounded w-full"
                  name="email_address"
                  aria-label="Email Address"
                  placeholder="Email Address*"
                  type="email"
                  required
                />
              </div>
              <div>
                <input
                  className="border border-solid border-gray-400 p-2 rounded w-[250px]"
                  aria-label="Most important feature for you"
                  name="fields[daytab_most_important_feature]"
                  placeholder="Most important feature for you"
                  type="text"
                />
              </div>
              <button
                type="submit"
                data-element="submit"
                className="bg-blue-300 px-5 drop-shadow-md rounded-2xl hover:bg-blue-400 transition-colors"
              >
                <div className="" />
                <span className="">Join waitlist</span>
              </button>
            </div>
          </div>
          <ul data-element="errors" data-group="alert" className="pt-1 text-red-600" />
        </form>
      </div>
    </main>
  );
}
